import React from "react";
import StripeContainer from "./StripeContainer";

const PaymentPage = ({ setUserPack, userData, setCart, cart }) => {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="card-body">
          <StripeContainer
            setUserPack={setUserPack}
            userData={userData}
            setCart={setCart}
            cart={cart}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
